import * as React from "react";

export class LeagueName extends React.Component<{
    name: string,
    showNumberOfEvents: boolean,
    count?: number
}, {}> {

    render() {
        return (
            <div className="rj-heading-2__text-container">
                <div className="rj-sports-multiview__league-heading-section rj-sports-multiview__league-heading-name">
                    {this.props.showNumberOfEvents && <span className="rj-sports-multiview__league-heading-event-counter">({this.props.count})</span>}
                    <span className="rj-sports-multiview__league-heading-name-value">{this.props.name}</span>
                </div>
            </div>
        )
    }
}